import { Link, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { RoutesLink } from "../../../../ApiHelper/RoutesLink";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import DeleteIcon from "../../../../components/Icons/DeleteIcon";
import EditIcon from "../../../../components/Icons/EditIcon";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";
import ViewIcon from "../../../../components/Icons/ViewIcon";
import moment from "moment";
import MainHeading from "../../../../components/comman/MainHeading";
import FilterComponent from "../../../../components/comman/FilterComponent";
import CommonTable from "../../../../components/comman/CommonTable";
import ConfirmModal from "../../../../components/comman/ConfirmModal";
import { MainFilterHandler } from "../../../../components/comman/MainFilterHandler";
import { useDispatch, useSelector } from "react-redux";
import {
  saveActiveEmpOnboardTab,
  updateFiltersStates,
} from "../../../../store/actions/UserActions";
import { printData } from "../../../../utility/CommonFunctions";
import ExportDataHandler from "../../../../utility/ExportDataHandler";
import BudgetLogs from "../../../Sites/BudgetRequests/BudgetLogs";
import DocumentIcon from "../../../../components/Icons/DocumentIcon";

export default function EmployeeOnBoard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ActiveTab = useSelector((state) => state?.root?.activeEmpOnboardTab);
  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const timeoutId = useRef(null);
  const [selectedId, setSelectedId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pageStates, setPageStates] = useState({
    empType: ActiveTab == "2" ? "0" : 1,
    tableLoader: false,
    employeeData: [],
    departmentList: [],
    designationList: [],
    searchQuery: "",
    department: "",
    designation: "",
    siteType: "",
    siteId: filterDetails?.siteId,
    siteList: [],
    companyList: [],
    companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
  });

  useEffect(() => {
    GetDepartments(ActiveTab);
    GetCompanyList();
  }, []);

  useEffect(() => {
    if (ActiveTab == 2) {
      GetSiteList(filterDetails?.companyId);
    }
  }, [filterDetails?.companyId]);

  useEffect(() => {
    if (filterDetails?.empStatus) {
      GetEmployeeList();
    }
  }, [
    filterDetails?.empStatus,
    filterDetails?.currentPage,
    filterDetails?.department,
    filterDetails?.designation,
    pageStates?.searchQuery,
    pageStates?.empType,
    filterDetails?.pageSize,
    filterDetails?.siteId,
    filterDetails?.companyId,
    filterDetails?.orderBy,
    pageStates?.isInitial,
  ]);

  const toggleTab = (tab) => {
    dispatch(saveActiveEmpOnboardTab(tab));
    if (tab == 1) {
      setPageStates((prev) => ({
        ...prev,
        searchQuery: "",
        empType: "1",
        siteId: "",
      }));
      dispatch(
        updateFiltersStates({
          currentPage: 1,
          companyId: "",
          pageSize: 10,
          empStatus: "current",
          department: "",
          designation: "",
        })
      );
      GetDepartments(tab);
    } else {
      setPageStates((prev) => ({
        ...prev,
        empType: "0",
        siteId: filterDetails?.siteId,
        searchQuery: "",
      }));
      dispatch(
        updateFiltersStates({
          currentPage: 1,
          companyId: "",
          pageSize: 10,
          empStatus: "current",
          department: "",
          designation: "",
        })
      );
      GetDepartments(tab);
      GetSiteList();
    }
  };

  const GetEmployeeList = () => {
    let options = {
      method: "GET",
    };
    const finalFilter = {
      ...filterDetails,
      siteId: pageStates?.siteId,
      empType: pageStates?.empType,
      searchQuery: pageStates?.searchQuery,
    };
    delete finalFilter?.sortByDate;
    let API =
      apiUrl.get_employee +
      `?${filterDetails?.empStatus ? `status=${filterDetails?.empStatus}&` : ""
      }` +
      MainFilterHandler(finalFilter);
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      employeeData: [],
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.user?.map((item) => ({
          ...item,
          empNameWithImage: item?.name + "##" + item?.profilePhoto,
          employeeStatus: item?.status,
          department: item?.department?.name,
          role: item?.designation?.name,
          dateOfJoin: item?.joiningDate
            ? moment(item?.joiningDate).format("DD/MM/YYYY")
            : "--",
          onRollCompany: item?.Company?.name,
          ...(Number(pageStates?.empType) === 1
            ? { siteName: item?.site?.name }
            : { siteName: item?.usersites[0]?.site?.name }),
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          employeeData: newData,
        }));
        dispatch(
          updateFiltersStates({
            count: response?.data?.pageInfo?.total,
            totalPages: response?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      })
    );
  };
  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };
  const HandleView = (data) => {
    navigate(`${RoutesLink?.employee_detail}/${data?.id}`);
  };

  const HandleUpdate = (data) => {
    if (userDetails?.department?.name === "HRM" && data?.department === "HRM") {
      toast.info("HRM cannot update its own department records");
    } else {
      navigate(RoutesLink?.add_employee_onboard, { state: { data: data } });
    }
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_customer + `?employeeId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggle();
        GetEmployeeList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
        toggle();
      }
    });
  };

  const HandleViewLogs = (data) => {
    navigate(RoutesLink?.user_logs, { state: { data: data } });
  };

  const TableHeading = [
    { value: "empNameWithImage", label: "Emp. Name" },
    { value: "employeeCode", label: "Emp. Code" },
    { value: "phone", label: "Phone No." },
    { value: "email", label: "Email" },
    { value: "dateOfJoin", label: "Joining Date" },
    { value: "department", label: "Emp. Dept." },
    { value: "role", label: "Emp. DESG." },
    { value: "onRollCompany", label: "On Roll Company" },
    ...(Number(pageStates?.empType) === 1
      ? [{ value: "siteName", label: "office" }]
      : [{ value: "siteName", label: "Site Name" }]),
    { value: "employeeStatus", label: "Status" },
    { value: "isSalaryCreated", label: "Salary" },
  ];

  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
    {
      label: "Logs",
      className: "btn btn-link",
      icon: <DocumentIcon />,
      title: "user logs",
      clickHandler: HandleViewLogs,
    },
    // {
    //   label: "Delete",
    //   className: "btn btn-link",
    //   icon: <DeleteIcon />,
    //   title: "",
    //   //   clickHandler: ActionHandler,
    // },
  ];

  const GetDesignations = (departmentId) => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_designation + `?departmentId=${departmentId}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          designationList: response?.data?.designation,
        }));
      }
    });
  };

  const sortHandler = (data, type = null) => {
    if (type === "department") {
      GetDesignations(data?.department);
    } else {
      setPageStates((prevState) => ({
        ...prevState,
        department: data?.department,
        designation: data?.designation,
        ...(type === "site" && { siteId: data?.site }),
        ...(type === "companyId" && { companyId: data?.companyId }),
        ...(type == "companyId" && {
          siteId: "",
        }),
      }));
      dispatch(
        updateFiltersStates({
          ...(type === "site" && { siteId: data?.site }),
          ...(type === "companyId" && { companyId: data?.companyId }),
          ...(type && { officeType: data?.office }),
          ...(!type && { department: data?.department }),
          ...(!type && { designation: data?.designation }),
          ...(!type && { empStatus: data?.status }),
        })
      );
    }
  };

  const GetDepartments = (type) => {
    const empType = type == "2" ? "0" : 1;
    let options = {
      method: "GET",
    };
    let API = `${apiUrl?.get_department}${empType == 0 ? "?type=site" : empType == 1 ? "?type=office" : ""
      }`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          departmentList: response?.data?.department,
        }));
      }
    });
  };
  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      const API =
        apiUrl.get_site +
        `?&pageSize=100&status=1` +
        (companyId ? `&companyId=${companyId}` : "") +
        (searchQuery ? `&search=${searchQuery}` : "");

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item.id,
              label: item.name,
            }));

            const siteId = response.data?.site?.some(
              (item) => item?.id == filterDetails?.siteId
            );
            setPageStates((prev) => ({
              ...prev,
              ...(siteId ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };

      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));

      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const sortList = {
    department: pageStates?.departmentList,
    designation: pageStates?.designationList,
    ...(ActiveTab === 2 && { site: pageStates.siteList }),
    companyList: pageStates?.companyList,
    userStatus: true,
  };

  const handleExport = () => {
    let data = {
      exportDataType: "user",
      userType: ActiveTab == 2 ? 0 : 1,
      ...(filterDetails?.companyId
        ? { companyId: filterDetails.companyId }
        : {}),
      ...(filterDetails?.siteId ? { siteId: filterDetails.siteId } : {}),
      ...(filterDetails?.empStatus ? { status: filterDetails.empStatus } : {}),
      ...(filterDetails?.department
        ? { departmentId: filterDetails.department }
        : {}),
      ...(filterDetails?.designation
        ? { designationId: filterDetails.designation }
        : {}),
    };
    ExportDataHandler(data);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <>
        <div className="content">
          <MainHeading
            title={"Employee Onboard"}
            buttonText={"Add Employee"}
            buttonIcon={<PlusIcon />}
            buttonLink={RoutesLink?.add_employee_onboard}
          />
          <div className="card mb-4">
            <div className="card-body">
              <Nav tabs className="nav nav-tabs border-0 mb-4">
                <NavItem className="nav-item">
                  <NavLink
                    className={
                      ActiveTab === 1
                        ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2 active"
                        : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(1)}
                  >
                    Office Staff
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem className="nav-item">
                  <NavLink
                    className={
                      ActiveTab === 2
                        ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                        : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(2)}
                  >
                    Site Staff
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={ActiveTab}>
                <TabPane tabId={1}>
                  <Fade in={ActiveTab === 1} timeout={200}>
                    <FilterComponent
                      handleExport={
                        pageStates?.employeeData?.length > 0
                          ? handleExport
                          : null
                      }
                      filterArray={sortList}
                      sortHandler={sortHandler}
                      handleData={sortHandler}
                      pageStates={pageStates}
                      handleSearch={handleSearchChange}
                      orderByHandler={orderByHandler}
                      orderByList={orderByList}
                      getCompany={GetCompanyList}
                    />
                    <CommonTable
                      TableHeading={TableHeading}
                      TableData={pageStates?.employeeData}
                      ActionData={ActionData}
                      currentPage={filterDetails?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      isLoading={pageStates?.tableLoader}
                      totalPages={filterDetails?.totalPages}
                      count={filterDetails?.count}
                      handleChangePageSize={handleChangePageSize}
                      pageSize={filterDetails.pageSize}
                    />
                  </Fade>
                </TabPane>
                <TabPane tabId={2}>
                  <Fade in={ActiveTab === 2} timeout={200}>
                    <FilterComponent
                      handleExport={
                        pageStates?.employeeData?.length > 0
                          ? handleExport
                          : null
                      }
                      filterArray={sortList}
                      sortHandler={sortHandler}
                      handleData={sortHandler}
                      pageStates={pageStates}
                      handleSearch={handleSearchChange}
                      orderByHandler={orderByHandler}
                      orderByList={orderByList}
                      setPageState={setPageStates}
                      getSite={GetSiteList}
                      getCompany={GetCompanyList}
                    />
                    <CommonTable
                      TableHeading={TableHeading}
                      TableData={pageStates?.employeeData}
                      ActionData={ActionData}
                      currentPage={filterDetails?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      isLoading={pageStates?.tableLoader}
                      totalPages={filterDetails?.totalPages}
                      count={filterDetails?.count}
                      handleChangePageSize={handleChangePageSize}
                      pageSize={filterDetails.pageSize}
                    />
                  </Fade>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      </>
      <ConfirmModal
        modal={modal}
        toggle={toggle}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
